<script lang="ts" setup>
import { ref } from 'vue'
import PhIcon from '@/components/PhIcon.vue'
import { useModalStore } from '@/stores/modal.store.ts'
import FormSearchHome from '@/components/form/FormSearchHome.vue'

const { showModal } = useModalStore()

const inputValue = ref<string>('')

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  if (target.value === '') return

  const text: string = target.value
  showModal('none', text, 'Search Result', FormSearchHome, { text })
}
</script>

<template>
  <div class="relative w-full">
    <input
      type="search"
      placeholder="Search something..."
      :value="inputValue"
      name="search"
      @change="onChange"
      class="w-full pl-11 pr-3 py-2.5 text-sm bg-stone-50 dark:bg-stone-800 border border-stone-300 dark:border-stone-700 rounded-full focus:border-blue-300 focus:outline-none focus:ring-4 focus:ring-blue-300/25 placeholder:text-stone-400 transition-colors duration-150"
    />
    <ph-icon name="magnifying-glass" class="absolute top-2 left-3"></ph-icon>
  </div>
</template>
